import { isNotDefined } from '@sgme/fp';

import { selectFlexiForwardTile } from '@/store/flexi-forward/selectors/tile.ts';
import { flexiForwardSlice } from '@/store/flexi-forward/slice.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { selectTab } from '@/store/tabs/selectors.ts';
import { tabsSlice } from '@/store/tabs/slice.ts';
import { selectTileIdsOfTab } from '@/store/workspace/selector.ts';

export const registerTabListenersForFlexiForward = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: tabsSlice.actions.changeClient,
    effect: async (action, api) => {
      const state = api.getState();

      const tab = selectTab(state, action.payload.tabId);

      if (isNotDefined(tab)) {
        return;
      }

      const allTileIds = [...selectTileIdsOfTab(state, tab)];
      const allFlexiForwardTileIds = allTileIds.filter((tileId) => selectFlexiForwardTile(state, tileId) !== undefined);

      for (const tileId of allFlexiForwardTileIds) {
        api.dispatch(
          flexiForwardSlice.actions.flexiForwardClientChanged({
            tileId,
            clientId: action.payload.clientId,
            isTabClientOverridden: false,
          }),
        );
      }
    },
  });
};
